/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Search_EmbeddingsInputs */

const en_search_embeddings = /** @type {(inputs: Search_EmbeddingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`embeddings`)
};

const zh_hans1_search_embeddings = /** @type {(inputs: Search_EmbeddingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`向量嵌入`)
};

const pt_br2_search_embeddings = /** @type {(inputs: Search_EmbeddingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`embeddings`)
};

const es_search_embeddings = /** @type {(inputs: Search_EmbeddingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`embeddings`)
};

const fr_search_embeddings = /** @type {(inputs: Search_EmbeddingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`embeddings`)
};

const de_search_embeddings = /** @type {(inputs: Search_EmbeddingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Embeddings`)
};

const ru_search_embeddings = /** @type {(inputs: Search_EmbeddingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`эмбеддинги`)
};

const it_search_embeddings = /** @type {(inputs: Search_EmbeddingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`embedding`)
};

/**
* | output |
* | --- |
* | "embeddings" |
*
* @param {Search_EmbeddingsInputs} inputs
* @param {{ locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }} options
* @returns {LocalizedString}
*/
export const search_embeddings = /** @type {((inputs?: Search_EmbeddingsInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Search_EmbeddingsInputs, { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh-Hans") return zh_hans1_search_embeddings(inputs)
	if (locale === "pt-BR") return pt_br2_search_embeddings(inputs)
	if (locale === "es") return es_search_embeddings(inputs)
	if (locale === "fr") return fr_search_embeddings(inputs)
	if (locale === "de") return de_search_embeddings(inputs)
	if (locale === "ru") return ru_search_embeddings(inputs)
	if (locale === "it") return it_search_embeddings(inputs)
	return en_search_embeddings(inputs)
});